if (!customElements.get('product-block')) {
  // Note: product-block gets .product-block class applied in Liquid
  // so it inherits all grid layout styles
  customElements.define('product-block', class extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
    }

    loadFullProductBlock(fetchUrl) {
      if (this.loaded) return;
      this.loaded = true;

      if (!fetchUrl) {
        console.error('[ProductBlock] No fetch URL provided');
        return;
      }

      fetch(fetchUrl)
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          // The fetched HTML is a complete .product-block
          const fullBlock = tempDiv.querySelector('.product-block');
          if (!fullBlock) {
            console.error('[ProductBlock] No .product-block found in fetched HTML');
            return;
          }

          // Update image container by keeping the first image completely untouched
          // and appending all new elements (secondary images, navigation, dots, labels, etc.)
          const currentImageCont = this.querySelector('.image-cont');
          const newImageCont = fullBlock.querySelector('.image-cont');

          if (currentImageCont && newImageCont) {
            // Keep the first image element completely untouched, append everything else

            const currentPrimaryImage = currentImageCont.querySelector('.product-block__image--primary');
            const newPrimaryImage = newImageCont.querySelector('.product-block__image--primary');

            if (currentPrimaryImage && newPrimaryImage) {
              // Get the wrapper that contains the primary image
              const currentWrapper = currentPrimaryImage.parentElement; // the <div>
              const newWrapper = newPrimaryImage.parentElement;

              if (currentWrapper && newWrapper) {
                // Append any additional images (secondary images) after the primary
                Array.from(newWrapper.children).forEach((child, index) => {
                  if (index > 0) { // Skip first child (primary image)
                    currentWrapper.appendChild(child.cloneNode(true));
                  }
                });

                // Now handle parent levels - append siblings at each level
                let currentParent = currentWrapper.parentElement;
                let newParent = newWrapper.parentElement;

                while (currentParent && newParent && currentParent.classList.contains('image-label-wrap') === false) {
                  Array.from(newParent.children).forEach((child, index) => {
                    if (index > 0) {
                      currentParent.appendChild(child.cloneNode(true));
                    }
                  });
                  currentParent = currentParent.parentElement;
                  newParent = newParent.parentElement;
                }

                // Handle image-label-wrap and its siblings
                const currentLabelWrap = currentImageCont.querySelector('.image-label-wrap');
                const newLabelWrap = newImageCont.querySelector('.image-label-wrap');
                if (currentLabelWrap && newLabelWrap) {
                  Array.from(newLabelWrap.children).forEach((child, index) => {
                    if (index > 0) {
                      currentLabelWrap.appendChild(child.cloneNode(true));
                    }
                  });
                }

                // Handle product-link siblings
                const currentProductLink = currentImageCont.querySelector('.product-link');
                const newProductLink = newImageCont.querySelector('.product-link');
                if (currentProductLink && newProductLink) {
                  Array.from(newProductLink.children).forEach((child, index) => {
                    if (index > 0) {
                      currentProductLink.appendChild(child.cloneNode(true));
                    }
                  });
                }

                // Handle image-cont direct children (labels, buttons, etc.)
                Array.from(newImageCont.children).forEach((child, index) => {
                  if (index > 0) {
                    currentImageCont.appendChild(child.cloneNode(true));
                  }
                });
              }
            }
          }

          // Replace product-info innerer section (swatches, promos, price details)
          const currentInfo = this.querySelector('.product-info .innerer');
          const newInfo = fullBlock.querySelector('.product-info .innerer');

          if (currentInfo && newInfo) {
            currentInfo.innerHTML = newInfo.innerHTML;
          }

          // Trigger theme-specific reinitialization
          if (window.theme && window.theme.ProductBlockManager) {
            // Load images (in case new images were added in swatches/variants)
            window.theme.ProductBlockManager.loadImages(this);
          }

          // Trigger any other theme initializations
          if (window.theme && window.theme.initAnimateOnScroll) {
            window.theme.initAnimateOnScroll();
          }

          this.classList.remove('product-block--lazy-load');
        })
        .catch(error => {
          console.error('[ProductBlock] Error loading product block:', error);
        });
    }

    connectedCallback() {
      // Only observe if this is a lazy-load skeleton (will be loaded via intersection observer)
      const fetchUrl = this.getAttribute('data-fetch-url');
      if (this.classList.contains('product-block--lazy-load') && fetchUrl) {
        // Check if inside a carousel (set via data attribute from Liquid)
        const isInCarousel = this.hasAttribute('data-in-carousel');

        // Set up Intersection Observer with different params for carousel vs. grid
        const observerOptions = isInCarousel
          ? { threshold: 0.1, rootMargin: '0px' } // Carousel: only load what's visible
          : { threshold: 0.2, rootMargin: '200px' }; // Grid: preload ahead

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                entry.target.loadFullProductBlock(fetchUrl);
              }
            });
          },
          observerOptions
        );

        this.observer.observe(this);

        // For carousel items, also listen for slide events to preload adjacent items
        if (isInCarousel) {
          this.handleCarouselSlide = () => {
            const myOwlItem = this.closest('.owl-item');
            if (!myOwlItem || myOwlItem.classList.contains('cloned')) return;

            // Check if the previous sibling is active (meaning we're next up)
            const prevSibling = myOwlItem.previousElementSibling;
            if (prevSibling && prevSibling.classList.contains('active')) {
              const fetchUrl = this.getAttribute('data-fetch-url');
              if (fetchUrl && !this.loaded) {
                this.loadFullProductBlock(fetchUrl);
              }
            }
          };

          document.addEventListener('carousel:slid', this.handleCarouselSlide);
        }
      }
    }

    disconnectedCallback() {
      // Clean up observer when element is removed from DOM
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      // Clean up carousel event listener
      if (this.handleCarouselSlide) {
        document.removeEventListener('carousel:slid', this.handleCarouselSlide);
        this.handleCarouselSlide = null;
      }
    }
  });
}

